<div class="basket {{ paymentClass }} {{isBasketPage && 'basket--page'}}"
    *ngIf="order != null && orderLines != null && orderLines.length > 0">

    <div class="{{isBasketPage && 'container-lg'}}">
        <div class=" {{isBasketPage && 'row'}}">
            <div class="{{isBasketPage && 'col-12 col-md-8'}}">
                <div class="basket-header">
                    <app-orderline-list [checkoutState]="checkoutState" [navigate-checkout]="navigateCheckout" [showFees]="showFees"
                        [show-per-month]="showPerMonth" [show-package-details]="isBasketPage" [price-factor]="classCount" [isBasketPage]="isBasketPage" [isCheckout]="isCheckout" [showAddMore]="isBasketPage">
                    
                    </app-orderline-list>
                </div>

                <div class="pricing-update" *ngIf="classCount > 1 && priceChangeInEffect"
                    [ngClass]="{'expanded': pricingUpdateExpanded}">
                    <app-pricing-update #pricingUpdate [order]="order" [expanded]="pricingUpdateExpanded"
                        (onExpand)="onPricingExpand()"></app-pricing-update>
                </div>

                <div class="payment-details pt-2" *ngIf="paymentDetailsVisible">
                    <div class="payment-details-cover">
                        <ng-container *ngIf="classCount === 6 || isBsAppActive">
                            Betalingen dækker over trækninger fra<br> <span>{{ drawDateFirst | date : "MMMM yyyy"
                                }}</span> til og
                            med <span>{{ drawDateLast | date : "MMMM yyyy" }}</span>
                        </ng-container>
                        <ng-container *ngIf="classCount === 1 && !isBsAppActive">
                            Betalingen dækker over trækningen i <span>{{ drawDateFirst | date : "MMMM yyyy" }}</span>
                        </ng-container>
                    </div>

                    <app-playing-months [checkoutState]="checkoutState"></app-playing-months>

                    <div class="win-note d-none d-xl-block mt-xl-3">
                        <p>Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 % inden udbetaling.</p>
                    </div>
                </div>

                <div *ngIf="classCount === 1 && paymentDetailsVisible && priceChangeInEffect"
                    class="pricing-update expanded mt-2">
                    <div class="pricing-update-content">
                        <strong>Nye priser fra 2022</strong>
                        <p>
                            Lodpriserne justeres fra april 2022.
                        </p>
                        <strong><a (click)="onShowPriceUpdateInfoClick()">Læs mere her</a></strong>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-md-4" *ngIf="isBasketPage">
                <div class="basket-summary" id="basket-summary">

                    <div class="basket-summary__row">
                        <div>
                            Min - max gevinst
                        </div>
                        <div class="basket-summary__number">{{minPrize | money}} - {{topPrize | money}}</div>
                    </div>

                    <div class="basket-summary__divider"></div>

                    <div class="basket-summary__row">
                        <div class="basket-summary__total">
                         <ng-container *ngIf="priceTotal"> {{priceTotal | money}}/md </ng-container>
                        </div>
                        <div >
                            <button class="cta cta--primary" routerLink="/betaling"
                                [disabled]="disabled" (click)="onContinueToPaymentClick()" *ngIf="navigateCheckout">
                                Fortsæt til køb
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>